import React from "react";
import { Link } from "react-router-dom";

import { allProjects } from "../../data/projects";
import "./project-styles.css";

export function ProjectHeader({ title, subheading, client, year, role, status, users }) {
	const details = [
		{ label: "Status", value: status },
		{ label: "Client", value: client },
		{ label: "Role", value: role },
		{ label: "Year", value: year },
		{ label: "For", value: users },
	].filter((item) => item.value);

	return (
		<header className="project-header">
			<div className="main-content">
				<h1 className="project-title black-text">{title}</h1>
				<p className="subheading black">{subheading}</p>
			</div>
			<dl className="side-content">
				{details.map((item) => (
					<div className="item" key={item.label}>
						<dt className="label">{item.label}</dt>
						<dd className="value">{item.value}</dd>
					</div>
				))}
			</dl>
		</header>
	);
}

export function ProjectImage({ src, alt }) {
	return (
		<div className="project-img">
			<img src={src} alt={alt} />
		</div>
	);
}

export function ProjectBody({ title, children }) {
	return (
		<section className="project-body">
			{title && <h2 className="project-section-title">{title}</h2>}
			{children}
		</section>
	);
}

export function UnorderedList({ items }) {
	return (
		<ul>
			{items.map((item, index) => (
				<li key={index}>{item}</li>
			))}
		</ul>
	);
}

export function OrderedList({ items }) {
	return (
		<ol>
			{items.map((item, index) => (
				<li key={index}>{item}</li>
			))}
		</ol>
	);
}

// "Back to work" plus a link to the next project, so no project page is a
// dead end.
export function ProjectFooterNav({ slug }) {
	const index = allProjects.findIndex((project) => project.slug === slug);
	const next = allProjects[(index + 1) % allProjects.length];

	return (
		<nav className="project-nav" aria-label="More projects">
			<Link to="/work">← All work</Link>
			{next && next.slug !== slug && (
				<Link to={`/works/${next.slug}`}>Next: {next.name} →</Link>
			)}
		</nav>
	);
}
